module.exports = __webpack_public_path__ + "static/media/BANDHANBNK_F1.6cca76cd.txt";